import { ConfiguredMiddleware } from 'wretch/types'

import {
  createAuthClient as _createAuthClient,
  createSportsApiClient,
  HttpClient,
  withUnauthorizedCatcher,
} from '@collector/sportsapi-client'
import { Env } from '@desktop/envs'
import { setSportsApiClient } from '@desktop/globalState/sportsApiClient'

export function createAuthClient(token: string): HttpClient {
  return _createAuthClient(Env.VITE_SPORTS_API_URL, token)
}

export function initSportsApiClient(
  accessToken: string,
  refreshAuth: () => Promise<{ accessToken: string }>,
  middlewares: ConfiguredMiddleware[],
): void {
  const httpClient = createAuthClient(accessToken).middlewares(middlewares)
  const withCatcher = withUnauthorizedCatcher(httpClient, refreshAuth)
  const sportsApiClient = createSportsApiClient(withCatcher)

  setSportsApiClient(sportsApiClient)
}
